import { render } from "./VDropdownDivider.vue?vue&type=template&id=6b637d59&ts=true"
import script from "./VDropdownDivider.vue?vue&type=script&lang=ts"
export * from "./VDropdownDivider.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3176072795/src/johnson-inspection-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__